module.exports = __webpack_public_path__ + "img/logo.8bea506e.png";